export default {
  computed: {
    percentageValues() {
      return this.getTotal(
        this.filterValues('PERCENTUAL'),
      );
    },
    currencyConvert() {
      return this.formatCurrency(
        this.getTotal(
          this.filterValues('FIXO'),
        ),
      );
    },
    getValue() {
      const items = this.value[
        this.columnValueType
      ] || [];

      return items.filter(
        (item) => item.tipoComissaoTemplate === this.columnType,
      );
    },
  },
  methods: {
    filterValues(type) {
      return this.getValue.filter(
        (item) => item.tipoValorTemplate === type,
      );
    },
    getTotal(items = []) {
      return items.reduce(
        (total, item) => total + Number(item.valor),
        0,
      );
    },
    formatCurrency(amount) {
      return Number(amount).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },
  },
};
